import React, { lazy } from 'react';
import { MoonIcon, ActivityIcon, GaugeIcon, CloudRainIcon, SearchXIcon, BatteryLowIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const PAIN_IMG = 'https://cdn.magicpatterns.com/uploads/eV3j7g2Ps3DkLs1NYncXvg/dolor.webp';
const painPoints = [{
  icon: MoonIcon,
  text: 'Te despiertas cansada aunque hayas dormido'
}, {
  icon: ActivityIcon,
  text: 'Tu cuerpo está inflamado sin razón aparente'
}, {
  icon: GaugeIcon,
  text: 'Tu metabolismo parece haberse detenido'
}, {
  icon: CloudRainIcon,
  text: 'Los cambios de humor controlan tu vida'
}, {
  icon: SearchXIcon,
  text: 'Sientes que probaste todo y nada funciona'
}, {
  icon: BatteryLowIcon,
  text: 'Tu energía desaparece antes del mediodía'
}];
export function PainSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-109" data-mp="22a9s61uwzi4x">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16" data-id="element-110" data-mp="278ui98ggclfn">
        <Reveal className="order-2 lg:order-1" data-id="element-111" data-mp="3rlzhtd3aw1nv">
          <div className="overflow-hidden rounded-3xl shadow-xl shadow-tinta/10" data-id="element-112" data-mp="3rovg52j28scu">
            <img src={PAIN_IMG} alt="Mujer cansada mirando por la ventana en un día lluvioso, sosteniendo una taza" className="h-full max-h-[560px] w-full object-cover" loading="lazy" data-id="element-113" data-mp="3nl5vgo5iaux3" />
          </div>
        </Reveal>

        <div className="order-1 lg:order-2" data-id="element-114" data-mp="38x2md5w63342">
          <Reveal data-id="element-115" data-mp="33xg6eooyf8rk">
            <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-116" data-mp="33xyc0bxiazc5">
              ¿Te identificas con esto?
            </h2>
            <p className="mt-4 text-lg text-tinta/70" data-id="element-117" data-mp="3iofg631j03cq">
              No estás sola, ni te estás inventando nada. Tu cuerpo te está
              hablando y merece que lo escuches.
            </p>
          </Reveal>

          <ul className="mt-8 space-y-4" data-id="element-118" data-mp="2l6yjx1upt9en">
            {painPoints.map((p, i) => <Reveal as="li" key={p.text} delay={i * 0.07} data-id="element-119" data-mp="2l4uhkocgsigh" data-mpi={i}>
                <div className="flex items-start gap-4 rounded-2xl bg-crema/70 p-4 sm:p-5" data-id="element-120" data-mp="p30v3bujdfz5">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-rosa/15 text-rosa-dark" data-id="element-121" data-mp="u1vd4bkoj0i7">
                    <p.icon className="h-5 w-5" strokeWidth={1.7} data-id="element-122" data-mp="yuezny1ch5z5" />
                  </span>
                  <span className="pt-2 text-base leading-snug text-tinta/85 sm:text-lg" data-id="element-123" data-mp="12up7zhcm08h6">
                    {p.text}
                  </span>
                </div>
              </Reveal>)}
          </ul>
        </div>
      </div>
    </section>;
}